import { render } from "./number-of-open-and-closed-sessions.vue?vue&type=template&id=05411021"
import script from "./number-of-open-and-closed-sessions.vue?vue&type=script&lang=ts"
export * from "./number-of-open-and-closed-sessions.vue?vue&type=script&lang=ts"

import "./number-of-open-and-closed-sessions.vue?vue&type=style&index=0&id=05411021&lang=less"
script.render = render

export default script